import { render } from "./CxRecovery.vue?vue&type=template&id=182a677a&ts=true"
import script from "./CxRecovery.vue?vue&type=script&lang=ts"
export * from "./CxRecovery.vue?vue&type=script&lang=ts"

import "./CxRecovery.vue?vue&type=style&index=0&id=182a677a&lang=less"

import exportComponent from "/home/ec2-user/workspace/_ui_production_production-1.59.1/microfrontends/conx-ui-login/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__